import { render, staticRenderFns } from "./ManagePermissions.vue?vue&type=template&id=23cb1d3a&"
import script from "./ManagePermissions.vue?vue&type=script&lang=js&"
export * from "./ManagePermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports